export function groupObjectByKey<T>(object: T[], getKeys: (item: T) => string): Record<string, T[]> {
  return object.reduce(
    (acc, item) => {
      const key = getKeys(item);
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    },
    {} as Record<string, T[]>
  );
}
